<template>
  <div class="footer">
    <div class="footer-content">
      <div>
        <div class="footer-name" @click="navTo('Home')">湖南檀浏信息技术有限公司</div>
        <div class="footer-name2" @click="navTo('Home')">Hunan tanliu Information Technology Co., Ltd</div>
        <div class="footer-info">
          <p>地址：湖南长沙市岳麓区岳麓西大道2450号环创园A4栋605</p>
          <p> 邮箱：vip@tanner-china.com</p>
        </div>
      </div>
      <div style="margin-left: 74px;">
        <img src="../assets/footer-service.png" class="footer-service">
        <div class="footer-service-content">
          <div>
            <p @click="navTo('Service')">服务范围</p>
            <p @click="navTo('Production')">产品中心</p>
          </div>
          <div style="margin-left: 74px">
            <p @click="navTo('AboutUs')">关于我们</p>
            <p @click="navTo('JoinUs')">加入我们</p>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-concat"></div>
        <div class="footer-code"></div>
        <div class="footer-tip">
          <div class="code-tip">微信扫一扫</div>
          <div class="code-tip">了解更多资讯</div>
        </div>
      </div>
    </div>
    <div class="beian-button" @click="toLookBeiAn()"></div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    methods:{
      navTo(name){
        this.$router.push({name})
      },
      toLookBeiAn(){
        window.open("http://beian.miit.gov.cn/",'blank')
      }
    }
  }
</script>

<style scoped>
  .footer {
    width: 100%;
    margin: 0 auto;
    height: 429px;
    position: relative;
  }
  .beian-button{
    width: 380px;
    height: 22px;
    position: absolute;
    bottom: 50px;
    left: 50%;
    margin-left: -190px;
    cursor: pointer;
  }
  .footer-content{
    width: 1920px;
    height: 429px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
    display: flex;
    background-image: url("../assets/home_bg4.png");
    justify-content: center;
  }

  .footer-name {
    font-size: 24px;
    font-family: YouSheBiaoTiHei;
    color: #fff;
    letter-spacing: 1px;
    margin-top: 82px;
  }
  .footer-name2{
    font-size: 12px;
    font-family: YouSheBiaoTiHei;
    color: #fff;
    line-height: 16px;
    opacity: 0.5;
  }

  .footer-info {
    font-size: 16px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
    opacity: 0.5;
    margin-top: 16px;
  }

  .footer-service {
    width: 62px;
    height: 16px;
    margin-top: 88px;
  }

  .footer-service-content {
    margin-top: 30px;
    font-size: 16px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    opacity: 0.5;
    display: flex;
  }
  .footer-content p{
    cursor: pointer;
  }

  @media (min-width: 1200px) {
    .footer-right {
      margin-left: 201px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

  }

  @media (max-width: 1200px) {
    .footer-right {
      margin-left: 101px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

  }

  .footer-concat {
    margin-top: 85px;
    background-image: url("../assets/footer-concat.png");
    width: 108px;
    height: 16px;
    background-repeat: no-repeat;
  }

  .footer-code {
    background-image: url("../assets/ewm.png");
    width: 120px;
    height: 120px;
    margin-top: 22px;
    margin-right: -24px;
  }

  .code-tip {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 21px;
    opacity: 0.5;
  }
  .footer-tip{
    width: 120px;
    text-align: right;
    margin-top: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue